import vue from '@/main'
import axios from 'axios'
import moment from 'moment';
import state from '@/store/state'
import sha256 from 'crypto-js/sha256';
import fileHttp from "@/http/requests/file"
import {parsePhoneNumber as parsePhoneLib} from 'libphonenumber-js'
import metadata from 'libphonenumber-js/max/metadata'

export const replaceAll = (string, from, to) => {
  const stringLength = string.length
  let position = 0
  while (position < stringLength) {
    string = string.replace(from, to)
    position++
  }

  return string
}

export const moneyToFloat = (money) => {
  money = money.toString().replace('R$ ', '')
  money = replaceAll(replaceAll(money, ',', ''), '.', '')

  const unitPosition = money.length - 2
  money = parseFloat([
    money.slice(0, unitPosition),
    '.',
    money.slice(unitPosition)
  ].join(''))

  return money
}

export const maskMoney = (money, currency, divider = 100) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: currency
  }).format(money / divider);
}

export const paymentTypes = (message) => {
  let object = {};

  switch (message.subtype) {
    case 'request':
      Object.assign(object, { type: 'Requisição' })
      break
    case 'send':
      Object.assign(object, { type: 'Envio' })
      break
    case 'received':
      Object.assign(object, { type: 'Recebido' })
      break
    case 'payment_action_request_declined':
      Object.assign(object, { type: 'Recusado' })
      break
    default:
      Object.assign(object, { type: 'Sem informações' })
      break
  }

  switch (message.statusMessage) {
    case 'success':
      return Object.assign(object, { color: 'success', icon: 'done', text: 'Sucesso' })
    case 'request_sucess':
      if (message.expiryTimestamp) {
        let now = (new Date()).getTime();
        let expiryTimestamp = (new Date(message.expiryTimestamp  * 1000)).getTime();
        let daysToExpire = Math.ceil((expiryTimestamp - now) / (1000 * 60 * 60 * 24));

        if ( now > expiryTimestamp ) {
          return Object.assign(object, { color: 'danger', icon: 'report_problem', text: 'Expirou' })

        } else if ( daysToExpire > 0 ) {
          return Object.assign(object, { color: 'warning',  icon: 'schedule', text: `Pendente (Expira em ${daysToExpire} dias)` })
        }
      }

      return Object.assign(object, { color: 'warning', icon: 'schedule', text: 'Pendente' })
    case 'await':
      return Object.assign(object, { color: 'warning', icon: 'schedule', text: 'Em processamento' })
    default:
      return Object.assign(object, { color: 'danger', icon: 'report_problem', text: 'Sem informações' })
  }
}

export const b64DecodeUnicode = (str) => {
    return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}

export const formatTenantPath = (string) => {
  return '/:tenant' + string
}

export const getBaseUrl = () => {
  return process.env.VUE_APP_BASE_URL;
}

export const getCurrentTenant = () => {
  return window.location.href.replace(process.env.VUE_APP_BASE_URL, '').split('/')[0];
}

export const getCurrentRoute = () => {
  const route = window.location.href.replace(process.env.VUE_APP_BASE_URL, '').split('/');

  delete route[0];
  return route.join('/');
}

export const formatRouteTenantPath = (route) => {
  return '/' + getCurrentTenant() + route
}

export const encodeToBase64 = content => {
  return btoa(unescape(encodeURIComponent(content.replaceAll('Ÿ', 'Y'))))
}

export const decodeFromBase64 = content => {
  try {
    return decodeURIComponent(escape(atob(content)))
  } catch (error) {
    return content;
  }
}

export const parseItemFromObjectToString = (index, item, isLastItem) => {
  if (typeof item === 'object') {
      item = index + ` { ` + parseObjectToString(item) + ` }`;
  }

  return item + (isLastItem ? '' : ', ');
}

export const parseParamFromObjectToString = (item) => {
  let string = '{ '

  for (const [index, value] of Object.entries(item)) {
    if (value === null){ continue; }

    if (typeof value === 'object' && !(value instanceof Array)) {
      string += index + ': { '
      for (const [name, param] of Object.entries(value)) {
        if (param instanceof Array) {
          string += name + ': [[ '
          for (const nestedParam of param[0]) {
            string += '"' + nestedParam + '",'
          }

          string += ' ]]'
        }
      }
      string += ' },'
      continue
    }
    string += parseParamToString(index, value)
  }

  return string + ' }'
}

export const removeFileFromBucket = (fileUrl) => {
  const urlArray = fileUrl.split("/");
  const filename = urlArray[urlArray.length - 1]

  const headers = {
    Authorization: 'Bearer ' + state.auth.bearer
  }

  return fileHttp
    .delete(filename, headers)
    .catch(err => {
      console.error(err)
    })
}

export const parseObjectToString = (object) => {
  let objectString = ''

  const objectIndexes = Object.keys(object)
  const objectValues = Object.values(object)

  for (const [index, item] of Object.entries(object)) {
    objectString += parseItemFromObjectToString(
      index,
      item,
      (
        objectIndexes[objectIndexes.length - 1] === index &&
        objectIndexes[objectValues.length - 1] === item
      )
    )
  }

  return objectString
}

export const parseParamToString = (item, value) => {
  if (typeof value === 'string') {
      return item + `: "` + value + `", `;
  }

  if (typeof value === 'object' && value !== null) {
    let param = '[';
    for (const data of value) {
      if (data === undefined || data === null){
        continue;
      }
      if (data.toString() === '[object Object]') {
        param += parseParamFromObjectToString(data) + ', '
        continue;
      }
      param += '"' + data + '", '
    }
    return item + `: ` + param + '], ';
  }

  return item + `: ` + value + ', ';
}

export const parseObjectParamsToString = (params, parentheses = true) => {
  if (Object.keys(params).length === 0) {
      return '';
  }

  let objectString = '';

  for (const [index, item] of Object.entries(params)) {
    objectString += parseParamToString(index, item);
  }

  if ( parentheses ) {
    return ` ( ` + objectString + ` )`;
  }

  return `{ ` + objectString + ` }`;
}

export const formatGraphqlBody = (type, functionName, responseItems = null, params = {}) => {
  const paramsItemsString = parseObjectParamsToString(params)

  if (responseItems === null) {
    return { query:  type + " { " + functionName + paramsItemsString + " } " }
  }

  const responseItemsString = parseObjectToString(responseItems)
  return { query:  type + " { " + functionName + paramsItemsString + " { " + responseItemsString + " } } " }
}

export const formatGraphqlParams = (params) => {
  const formattedParams = {}
  for (const [index, item] of Object.entries(params)) {
    if (item !== '' && item !== null && item !== undefined) {
      // if (typeof item === 'object') {
      //   formattedParams[index] = '["';
      //   for (const value of item) {
      //     if (value.toString() === '[object Object]') {
      //       formattedParams[index] = '{"';
      //       console.log(value);
      //       formattedParams[index] += JSON.stringify(value) + '", '
      //     } else {
      //       formattedParams[index] += value + '", '
      //     }
      //   }
      //   formattedParams[index] += ']';
      //   continue;
      // }
      formattedParams[index] = item
    }
  }

  return formattedParams
}

export const formatDate = (date) => {
  if (date === null || date === '') {
    return {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      full: '',
      date_only: ''
    };
  }

  const d = new Date(date);

  let day = d.getDate();
  let month = d.getMonth() + 1;
  const year = d.getFullYear();
  let hour = d.getHours();
  let minute = d.getMinutes();
  let second = d.getSeconds();

  if (day < 10) { day = `0${day}`; }
  if (month < 10) { month = `0${month}`; }
  if (hour < 10) { hour = `0${hour}`; }
  if (minute < 10) { minute = `0${minute}`; }
  if (second < 10) { second = `0${second}`; }

  return {
    day,
    month,
    year,
    hour,
    minute,
    second,
    full: `${day}/${month}/${year} ${hour}:${minute}:${second}`,
    date_only: `${day}/${month}/${year}`
  }
}

export const phoneNumberIsBrazilian = (phoneNumber) => {
  if (phoneNumber){
    let parsedNumber = phoneNumber.toString().replace(/[^0-9.]+/gi, '');
    let hasCode = parsedNumber.substring(0, 2) === "55";

    if (hasCode && parsedNumber.lenght > 13){
      parsedNumber = parsedNumber.substring(2);
      hasCode = false;
    }

    const phoneCode = '+' + parsedNumber;
    try {
      const phoneObject = parsePhoneLib(phoneCode);
      return (phoneObject.isValid() && phoneObject.country === 'BR') || hasCode
    } catch (e) {}
  }

  return true;
}

export const parsePhoneNumber = (phoneNumber) => {
  if (!phoneNumber) { return ''; }

  const parsedNumber = phoneNumber.toString().replace(/[^0-9.]+/gi, '');
  const hasCode = parsedNumber.substring(0, 2) === "55";

  if ( phoneNumberIsBrazilian(phoneNumber) ){
    return hasCode ? (parsedNumber.length <= 11 ? `55${parsedNumber}` : parsedNumber) : `55${parsedNumber}`;
  } else if (hasCode && parsedNumber.lenght > 13){
    return parsedNumber.substring(2);
  }

  return parsedNumber;
}

export const maskPhoneNumber = (phoneNumber) => {
  if ( !phoneNumber ) { return ''; }

  const parsedPhone = parsePhoneNumber(phoneNumber);
  const phoneCode = '+' + parsedPhone;

  try {
    const phoneObject = parsePhoneLib(phoneCode);
    if (phoneObject.isValid() && phoneObject.country !== 'BR'){
      return phoneObject.formatInternational();
    }
  } catch (e) {}

  return maskPhoneNumberToBrazilian(parsedPhone)
}

export const maskPhoneNumberToBrazilian = (phoneNumber) => {
  /**
   * If the phone number is in the old format: (XX) XXXXX-XXXX,
   * it'll be replaced to 55XXXXXXXXXXX
   */
  phoneNumber = parsePhoneNumber(phoneNumber);

  if (phoneNumber.startsWith("55800") || phoneNumber.startsWith("550800")) {
    const firstPart = phoneNumber.substring(2, 5);
    const secondPart = phoneNumber.substring(5, 8);
    const thirdPart = phoneNumber.substring(8);
    return `+55 ${firstPart} ${secondPart} ${thirdPart}`;
  }

  if (phoneNumber.substring(0, 2) !== "55"){
    phoneNumber = '55' + phoneNumber
  }

  const phoneLength = phoneNumber.length;
  const ddd = phoneNumber.substr(2, 2);
  const prefix = phoneNumber.substr(4, phoneLength === 12 ? 4 : 5);
  const suffix = phoneNumber.substr(phoneLength - 4, 4);

  return `+55 ${ddd} ${prefix} ${suffix}`;
}

export const maskLimitMessageTemplate= (currentLimit) => {
  if ( currentLimit && currentLimit.includes('UNLIMITED') ) {
    return 'Ilimitado';
  } else if ( currentLimit && currentLimit.length > 3 ) {
    return currentLimit.slice(0, -3) + 'mil';
  }
  return currentLimit
}

export const parseModelTemplateStatusOrColor = (status, getColor) => {
  if (
      status === 'APPROVED'
  ) { return getColor ? 'success' : 'Aprovado'; }

  else if (
      status === 'REJECTED'
  ) { return getColor ? 'danger' : 'Rejeitado'; }

  else if (
      status === 'PAUSED'
  ) { return getColor ? 'primary' : 'Pausado'; }

  else if (
      status === 'SUBMITTED' || status === 'PENDING'
  ) { return getColor ? 'warning' : 'Pendente'; }

  return getColor ? 'warning' : status;
}

export const parseConnectionStatusOrColor = (activated, getColor, intuitive = false) => {
  if (
      activated !== false && activated !== 'false' && activated !== 0 && activated !== '0'
  ) { return getColor ? 'success' : 'Conectado'; }

  return getColor ? 'danger' : (intuitive ? 'Reconectar-se' : 'Desconectado');
}

export const getChatOptionAsTreeChild = (chatOption, useNode = false, allExpanded = false, lastOpen = null) => {
  if (useNode) {
    return {
      title: chatOption.title,
      is_close: chatOption.is_close,
      expanded: allExpanded,
      type: chatOption.type,
      children: chatOption.children,
      priority: chatOption.priority,
      lenght: chatOption.description ? chatOption.description.trim().length : 0,
      userDepartment: chatOption.userDepartment ? chatOption.userDepartment.id : null,
      group: chatOption.group ? chatOption.group.id : null,
      reasonOption: chatOption.reasonOption ? chatOption.reasonOption.id : null,
      reason: chatOption.reasonOption ? chatOption.reasonOption.reason_id : null
      ?
      chatOption.children.map(
        option => getChatOptionAsTreeChild(option, true, true)
      )
      :
      []
    }
  }

  return {
    title: `${chatOption.id}|${chatOption.number}|${chatOption.userDepartment ? chatOption.userDepartment.id : ''}|${chatOption.priority !== null && chatOption.priority !== undefined && chatOption.priority !== '' ? chatOption.priority : ''}|${chatOption.number !== null && chatOption.number !== undefined && chatOption.number !== '' ? chatOption.number + ' - ' : ''}`
      + `${chatOption.description}`,
    expanded: !!lastOpen.includes(chatOption.id),
    is_close: chatOption.is_close,
    type: chatOption.type,
    lenght: chatOption.description ? chatOption.description.trim().length : 0,
    group: chatOption.group ? chatOption.group.id : null,
    reasonOption: chatOption.reasonOption ? chatOption.reasonOption.id : null,
    reason: chatOption.reasonOption ? chatOption.reasonOption.reason_id : null,
    children: chatOption.childOptions
    ?
    chatOption.childOptions.map(
      option => getChatOptionAsTreeChild(option, false, false, lastOpen)
    )
    :
    []
  }
}

export const getOptionDataFromNodeTitle = (nodeTitle, parent) => {
  const optionId = parseInt(nodeTitle.substr(0, nodeTitle.indexOf('|')));
  nodeTitle = nodeTitle.replace(`${optionId}|`, '')

  let optionNumber = nodeTitle.substr(0, nodeTitle.indexOf('|'));
  nodeTitle = nodeTitle.replace(`${optionNumber}|`, '')
  optionNumber = parseInt(optionNumber)

  let departmentId = nodeTitle.substr(0, nodeTitle.indexOf('|'));
  nodeTitle = nodeTitle.replace(`${departmentId}|`, '')
  departmentId = parseInt(departmentId)

  let priority = nodeTitle.substr(0, nodeTitle.indexOf('|'));
  nodeTitle = nodeTitle.replace(`${priority}|`, '')
  priority = parseInt(priority)

  let parentId;

  if (parent) {
    const parentTitle = parent.title
    parentId = parseInt(parentTitle.substr(0, parentTitle.indexOf('|')));
  }

  return {
    optionId,
    optionNumber,
    parentId,
    departmentId,
    priority,
    newNodeTitle: nodeTitle
  }
}

export const hasPermission = (permissionName) => {
  if (state.AppActiveUser.role) {
    return state.AppActiveUser.role.has_permission_routes.indexOf(permissionName) !== -1;
  }

  return false
}

export const confirmHasFeature = (featureName, features) => {
  if (features.length.length === 0) { return false; }

  const featureIndex = features.findIndex((f) => f.name === featureName)
  if (featureIndex === -1) { return false; }

  return state.features.features[featureIndex].enabled === 'true'
}

export const hasFeature = async (featureName) => {
  if (vue.$store.state.AppActiveUser.id !== undefined) {
    if (state.features.features.length === 0 && state.features.assembled === false) {
      await vue.$store.dispatch("features/fetch")
    }

    return confirmHasFeature(featureName, state.features.features)
  }

  return false
}

export const hasCloud = async () => {
  if (vue.$store.state.AppActiveUser.id !== undefined) {
    if (state.instance.instances.length === 0) {
      await vue.$store.dispatch("instance/existsCloudConnection")
    }

    return state.instance.existsCloudConnection
  }

  return false
}

export const instanceObject = (instanceId) => {
  if (instanceId && typeof instanceId === 'object' && instanceId.length){
    return state.instance.instances.filter(instance => instanceId.includes(instance.id))
  }

  return instanceId ? state.instance.instances.find(instance => instance.id === instanceId) : null;
}

export const lowerCaseFirstLetter = (string) => {
  return string.charAt(0).toLowerCase() + string.slice(1);
}

export const delay = async (ms) => {
    return new Promise(resolve => setTimeout(() => resolve(), ms));
};

export const formatDateZeros = (number) => {
  if (number <= 9) {
    return "0" + number;
  }

  return number;
}

export const filterChat = (origin, item) => {
  return item.filter(chatContacts => {
    if (origin == 'campaign' ) {
      return (
        chatContacts.campaign.name != "Resposta passiva" &&
        chatContacts.customerLastChat.is_bot_message === true
      )
    } else if ( origin == 'attendance' ) {
      return (
        chatContacts.campaign_id === null ||
        chatContacts.campaign.name == "Resposta passiva" ||
        chatContacts.customerLastChat.is_bot_message === false
      )
    } else {
      return true
    }
  });
}

export const generateHash = (customerId, message, userId, instanceId) => {
  let currentTime = new Date()
  let hash = sha256(customerId + message + userId + instanceId + currentTime.getMilliseconds());

  return hash.toString();
}

export const populateParamTab = (tab, isCampaign, botIsActive, unseenMsg) => {
  const activeUser = state.AppActiveUser
  const department = tab === 'inbox' && activeUser.role.name !== 'administrador' && activeUser.userDepartment ? activeUser.userDepartment.id : null;

  if (isCampaign === null) {
    isCampaign = state.chatContact.chatFilter === 'campaign';
  }
  if (botIsActive === null) {
    botIsActive = state.chatContact.chatFilter === 'maria';
  }
  if (unseenMsg === null) {
    unseenMsg = state.chatContact.chatFilter === 'unseenMsg';
  }

  const param = {
    inbox: () => {
      return {
        instanceIds: vue.$store.getters["instance/chosenInstanceIds"],
        groupIds: vue.$store.getters["chatContact/groupsSelectedFilter"],
        isCampaign: isCampaign,
        botIsActive: botIsActive,
        unseenMsg: unseenMsg,
        finishedTickets: false,
        allUsers: true,
        inbox: true,
        inboxDepartment: department
      }
    },
    my_chats: () => {
      return {
        instanceIds: vue.$store.getters["instance/chosenInstanceIds"],
        groupIds: vue.$store.getters["chatContact/groupsSelectedFilter"],
        isCampaign: isCampaign,
        botIsActive: botIsActive,
        unseenMsg: unseenMsg,
        finishedTickets: false,
        allUsers: false
      }
    },
    opened: () => {
      return {
        instanceIds: vue.$store.getters["instance/chosenInstanceIds"],
        groupIds: vue.$store.getters["chatContact/groupsSelectedFilter"],
        isCampaign: isCampaign,
        botIsActive: botIsActive,
        unseenMsg: unseenMsg,
        finishedTickets: false,
        allUsers: true
      }
    },
    closed: () => {
      return {
        instanceIds: vue.$store.getters["instance/chosenInstanceIds"],
        groupIds: vue.$store.getters["chatContact/groupsSelectedFilter"],
        isCampaign: isCampaign,
        botIsActive: botIsActive,
        unseenMsg: unseenMsg,
        finishedTickets: true,
        allUsers: true
      }
    },
    all: () => {
      return {
        instanceIds: vue.$store.getters["instance/chosenInstanceIds"],
        groupIds: vue.$store.getters["chatContact/groupsSelectedFilter"],
        isCampaign: isCampaign,
        botIsActive: botIsActive,
        unseenMsg: unseenMsg,
        allUsers: true
      }
    }
  }

  return param[tab]();
}

export const populateQuerySum = async (cgService, chatFilter, ticket) => {
  const additionalChatFilter = vue.$store.state.chatContact.additionalChatFilter;

  const query = {
    attendance: async (ticket) => await conditionAdditional(
      (
        !ticket.is_campaign
        && vue.$store.getters["instance/chosenInstanceIds"].includes(ticket.instance_id)
        && await cgService.hasInFilter(ticket.customer_id)
      ),
      ticket
    ),
    campaign: async (ticket) => await conditionAdditional(
      (
        ticket.is_campaign
        && vue.$store.getters["instance/chosenInstanceIds"].includes(ticket.instance_id)
        && await cgService.hasInFilter(ticket.customer_id)
      ),
      ticket
    ),
    maria: async (ticket) => await conditionAdditional(
      (
        ticket.bot_is_active
        && vue.$store.getters["instance/chosenInstanceIds"].includes(ticket.instance_id)
        && await cgService.hasInFilter(ticket.customer_id)
      ),
      ticket
    ),
    unseenMsg: async (ticket) => await conditionAdditional(
      (
        ticket.unseenMsg > 0
        && vue.$store.getters["instance/chosenInstanceIds"].includes(ticket.instance_id)
        && await cgService.hasInFilter(ticket.customer_id)
      ),
      ticket
    ),
    all: async (ticket) => await conditionAdditional(
      (
        vue.$store.getters["instance/chosenInstanceIds"].includes(ticket.instance_id)
        && await cgService.hasInFilter(ticket.customer_id)
      ),
      ticket
    )
  }

  const conditionAdditional = async (condition, ticket) => {
    if (!additionalChatFilter || additionalChatFilter !== 'search'){
      return (await condition) && !ticket.is_research;
    }

    return (await condition);
  };

  return await query[chatFilter](ticket)
}

export const phoneMask = (value) => {
  value = value.replace(/[^0-9]+/g, '')
  if (value[0] === '5' && value[1] === '5') {
    value = value.replace('55', '');
  }
  if (value.length === 10) {
    return value
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{4})(\d)/, "$1-$2")
        .replace(/(-\d{4})(\d+?)$/, "$1");
  } else {
    return value
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{5})(\d)/, "$1-$2")
        .replace(/(-\d{4})(\d+?)$/, "$1");
  }
}

export const getUserDepartment = () => {
  return state.AppActiveUser.userDepartment ? state.AppActiveUser.userDepartment.id : 0;
}

export const isUrl = (text) => {
  const urlPattern = /^(https?:\/\/)?\S+\.\S+$/i;
  return text && urlPattern.test(text);
}

export const parseTime = (time) => {
  const now = new Date().getTime();
  const diff = now - (new Date(time)).getTime();
  const timeTypes = [
    [60 * 1000, "min"],
    [60 * 60 * 1000, "horas"],
    [24 * 60 * 60 * 1000, "dias"],
    [7 * 24 * 60 * 60 * 1000, "semanas"],
    [30 * 24 * 60 * 60 * 1000, "meses"],
    [365 * 24 * 60 * 60 * 1000, "anos"]
  ];

  for (let i = timeTypes.length - 1; i >= 0; i--) {
    const [time, unity] = timeTypes[i];
    if (diff >= time) {
      const value = Math.floor(diff / time);
      return value + " " + unity;
    }
  }

  return "1 min";
}

export const stylizeMessage = (message) => {
  const htmlFormat = [
    { symbol: '*', tag: 'b' },
    { symbol: '_', tag: 'em' },
    { symbol: '~', tag: 'del' },
    { symbol: '`', tag: 'code' },
  ];

  const url = /(https?:\/\/[^\s]+)/gi;
  const issetUrl = url.test(message);

  if (!issetUrl) {
    htmlFormat.forEach(({symbol, tag}) => {
      if (!message) return;

      const regex = new RegExp(`\\${symbol}([^${symbol}]*)\\${symbol}`, 'gm');
      const match = message.match(regex);
      if (!match) return;

      match.forEach(m => {
        let formatted = m;
        for (let index = 0; index < 2; index++) {
          formatted = formatted.replace(symbol, `<${index > 0 ? '/' : ''}${tag}>`);
        }
        message = message.replace(m, formatted);
      });
    });
  } else {
    message = message.replace(url, '<a href="$1" style="color:#4F6D7A" target="_blank">$1</a>');
  }

  const botMessage = "_As mensagens trocadas no inicio desta conversa são feitas através de um Bot :)_";
  const botItalicMessage = "<i>As mensagens trocadas no inicio desta conversa são feitas através de um Bot :)</i>";

  if (message.endsWith(botMessage)) {
    message = message.slice(0, -botMessage.length) + botItalicMessage;
  }

  if (/^\*([^*]+)\*/.test(message)) {
    message = message.replace(/\*([^*]+)\*/g, "<b>$1</b>");
  }

  message = message.replace(/</g, "&lt;").replace(/>/g, "&gt;");

  htmlFormat.forEach(({ tag }) => {
    const openTag = new RegExp(`&lt;${tag}&gt;`, 'g');
    const closeTag = new RegExp(`&lt;/${tag}&gt;`, 'g');
    message = message.replace(openTag, `<${tag}>`).replace(closeTag, `</${tag}>`);
  });

  message = message.replace(/&lt;a href="([^"]+)" style="color:#4F6D7A" target="_blank"&gt;/g, '<a href="$1" style="color:#4F6D7A" target="_blank">').replace(/&lt;\/a&gt;/g, '</a>');

  return message;
}

export const redirectTo = (url) => {
  window.open(url, '_blank');
}

export const filterPassword = (password) => {
  const weak = 50;
  const average = 75;
  const strong = 100;

  if (/(\w)\1{2,}/.test(password)) {
    return weak;
  }
  if (/(\d)\1{2,}/.test(password)) {
    return weak;
  }
  if (/(?:012|123|234|345|456|567|678|789|890|abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz)/i.test(password)) {
    return weak;
  }
  if (password.length < 8) {
    return weak;
  }
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(password) || !/(?=(.*?[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]){2})/.test(password)) {
    return average;
  }
  if (!/(?=.*[a-z])(?=.*[A-Z])/.test(password)) {
    return average;
  }
  return strong;
}


export const getTimeZone = (data, exec, show) => {
   
  let date,
      time,
      dateTime,
      datePart,
      dateParts,
      timeDefault,
      timePattern,
      dateTimeParts,
      timeZoneDefault,
      dateTimePattern,
      timeZoneCustomer,
      hoursTimeZoneDefault,
      hoursTimeZoneCustomer,
      convertedDateTimeString;

  date   = new Date();

  timeZoneDefault  = process.env.VUE_APP_TIME_ZONE_DEFAULT || 'America/Sao_Paulo';
  timeZoneCustomer = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // hh:mm
  timePattern = /^\d{2}:\d{2}$/
  
  // yyyy-mm-dd hh:mm:ss
  dateTimePattern = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/

  hoursTimeZoneDefault = date.toLocaleString(undefined, {
      hour:   '2-digit',
      hour12:  false,
      minute: '2-digit',
      timeZone: timeZoneDefault
  });
  hoursTimeZoneCustomer = date.toLocaleString(undefined, {
      hour:   '2-digit',
      hour12:  false,
      minute: '2-digit',
      timeZone: timeZoneCustomer
  });

  const customerTime = moment(hoursTimeZoneCustomer, 'HH:mm');
  const defaultTime = moment(hoursTimeZoneDefault, 'HH:mm');
  const diff = customerTime.diff(defaultTime);
  const duration = moment.duration(diff);
  const hours = duration.hours();

  if (data !== null && timePattern.test(data)) {
    time = moment(data, 'HH:mm');

    if (exec === 'campaign') {

      if (show !== false) {
        if (hoursTimeZoneCustomer > hoursTimeZoneDefault) {
          timeDefault = time.add(Math.abs(hours), 'hours');
          return timeDefault.format('HH:mm:ss');
    
        } else if (hoursTimeZoneCustomer < hoursTimeZoneDefault) {
          timeDefault = time.subtract(Math.abs(hours), 'hours');
          return timeDefault.format('HH:mm:ss');
        } else {
            return time.format('HH:mm:ss')
        }
      } else {
        if (hoursTimeZoneCustomer > hoursTimeZoneDefault) {
          timeDefault = time.subtract(Math.abs(hours), 'hours');
          return timeDefault.format('HH:mm');
    
        } else if (hoursTimeZoneCustomer < hoursTimeZoneDefault) {
          timeDefault = time.add(Math.abs(hours), 'hours');
          return timeDefault.format('HH:mm');
        } else {
            return time.format('HH:mm')
        }
      }
      

    } else if (exec === 'campaign-start') {

      if (hoursTimeZoneCustomer > hoursTimeZoneDefault) {
        timeDefault = time.subtract(Math.abs(hours), 'hours');
        return timeDefault.format('HH:mm');
  
      } else if (hoursTimeZoneCustomer < hoursTimeZoneDefault) {
        timeDefault = time.add(Math.abs(hours), 'hours');
        return timeDefault.format('HH:mm');
      } else {
          return time.format('HH:mm')
      }

    } else if (exec === 'campaign-finish') {

      if (hoursTimeZoneCustomer > hoursTimeZoneDefault) {
        timeDefault = time.subtract(Math.abs(hours), 'hours');
        return timeDefault.format('HH:mm');
  
      } else if (hoursTimeZoneCustomer < hoursTimeZoneDefault) {
        timeDefault = time.add(Math.abs(hours), 'hours');
        return timeDefault.format('HH:mm');
      } else {
          return time.format('HH:mm')
      }

    } else if(exec === 'schedules') {

      if (show !== false) {

        if (hoursTimeZoneCustomer > hoursTimeZoneDefault) {
          timeDefault = time.add(Math.abs(hours), 'hours');
          return timeDefault.format('HH:mm');
    
        } else if (hoursTimeZoneCustomer < hoursTimeZoneDefault) {
          timeDefault = time.subtract(Math.abs(hours), 'hours');
          return timeDefault.format('HH:mm');

        } else {
            return time.format('HH:mm')
        }

      } else {

        if (hoursTimeZoneCustomer > hoursTimeZoneDefault) {
          timeDefault = time.subtract(Math.abs(hours), 'hours');
          return timeDefault.format('HH:mm');
    
        } else if (hoursTimeZoneCustomer < hoursTimeZoneDefault) {
          timeDefault = time.add(Math.abs(hours), 'hours');
          return timeDefault.format('HH:mm');

        } else {
            return time.format('HH:mm')
        }

      }

    } else if (exec === 'schedules-update') {
      if (show !== false) {

        if (hoursTimeZoneCustomer > hoursTimeZoneDefault) {
          timeDefault = time.subtract(Math.abs(hours), 'hours');
          return timeDefault.format('HH:mm');
    
        } else if (hoursTimeZoneCustomer < hoursTimeZoneDefault) {
          timeDefault = time.add(Math.abs(hours), 'hours');
          return timeDefault.format('HH:mm');

        } else {
            return time.format('HH:mm')
        }

      } else {

        if (hoursTimeZoneCustomer > hoursTimeZoneDefault) {
          timeDefault = time.subtract(Math.abs(hours), 'hours');
          return timeDefault.format('HH:mm');
    
        } else if (hoursTimeZoneCustomer < hoursTimeZoneDefault) {
          timeDefault = time.add(Math.abs(hours), 'hours');
          return timeDefault.format('HH:mm');

        } else {
            return time.format('HH:mm')
        }

      }
    } else {

      if (hoursTimeZoneCustomer > hoursTimeZoneDefault) {
        timeDefault = time.add(Math.abs(hours), 'hours');
        return timeDefault.format('HH:mm');
  
      } else if (hoursTimeZoneCustomer < hoursTimeZoneDefault) {
        timeDefault = time.subtract(Math.abs(hours), 'hours');
        return timeDefault.format('HH:mm');

      } else {
          return time.format('HH:mm')
      }
    }
  }

  if (data !== '' && dateTimePattern.test(data)) {
    dateTimeParts = data.split(' ');
    datePart      = dateTimeParts[0];
    dateParts     = datePart.split('-');
    convertedDateTimeString = `${dateParts[1]}/${dateParts[2]}/${dateParts[0]}, ${dateTimeParts[1]}`;
    dateTime = moment(convertedDateTimeString, 'MM/DD/YYYY, HH:mm:ss');

    if (exec === 'timeCount') {
      if (hoursTimeZoneCustomer > hoursTimeZoneDefault) {
          dateTime.add(Math.abs(hours), 'hours');
          return dateTime.format('YYYY-MM-DD HH:mm:ss')
      } else if (hoursTimeZoneCustomer < hoursTimeZoneDefault) {
          dateTime.subtract(Math.abs(hours), 'hours');
          return dateTime.format('YYYY-MM-DD HH:mm:ss')
      } else {
          return dateTime.format('YYYY-MM-DD HH:mm:ss')
      }
    } else {
      if (hoursTimeZoneCustomer > hoursTimeZoneDefault) {
        dateTime.add(Math.abs(hours), 'hours');
        return dateTime.format('DD/MM/YYYY HH:mm')
      } else if (hoursTimeZoneCustomer < hoursTimeZoneDefault) {
          dateTime.subtract(Math.abs(hours), 'hours');
          return dateTime.format('DD/MM/YYYY HH:mm')
      } else {
          return dateTime.format('DD/MM/YYYY HH:mm')
      }
    }
  }
}

export const ipToInt = (ip) => {
  return ip.split('.').reduce((acc, octet) => (acc << 8) + parseInt(octet, 10), 0);
}

export const inRangeIps = (ip) => {
  try {
    const ipInt = ipToInt(ip);
    let ranges = process.env.VUE_APP_LOGIN_ACCESS_TOKEN_OPEN_RANGES;
    if (!ranges || !ipInt) return false;

    ranges = ranges.split(',');

    for (const range of ranges) {
      const [base, maskLength] = range.split('/');
      const baseInt = ipToInt(base);
      const mask = ~(2 ** (32 - maskLength) - 1);
      if ((ipInt & mask) === (baseInt & mask)) {
        return true;
      }
    }

    return false;
  } catch (e) {
    console.error(e);
    return false;
  }
}

/**
* Retrieves the IP address by making a request to the ipify API.
*
* @return {string} The IP address as a string.
*/
export const getIp = async () => {
  try {
    const response = await axios.get('https://api.ipify.org?format=json', {
      timeout: 2000,
    });
    return response.data.ip;
  } catch (error) {
    console.error('Erro ao obter o endereço IP:', error);
    return "000.00.00.000";
  }
}